enum UiActionTypes {
  isLoadingTrue,
  isLoadingFalse,
  openModal,
  closeModal,
  unknownAction,
}

export default UiActionTypes;
